import { throwIfAuthRequirementError } from '../../../utils/authRequirements';
import { apiClient } from '../../common/apiClient';
import { ApiConvereter } from '../../converter';
import type { IMemberRepository as I } from './interface';

export class MemberRepository implements I {
  listInProject: I.ListInProject = async (params) => {
    const { projectId, signal } = params;
    const res = await apiClient.POST('/member/list-in-project', {
      signal,
      body: { projectId },
    });
    throwIfAuthRequirementError(res.error, { projectId });
    if (!res.data) throw new Error('authInfo not found');
    return res.data.map(ApiConvereter.Account.fromApi);
  };
}
